import { useState, useCallback } from 'react'
import { validEmailRegex } from '../../../core/constants/common'
import { p2e } from '../../../core/utils/common'
import { VALIDATION_STATUS } from './constants'

/**
 * Hook to manage email validation state and logic
 */
export const useEmailValidation = () => {
	const [validationStatus, setValidationStatus] = useState(VALIDATION_STATUS.NORMAL)
	const [signMethod, setSignMethod] = useState(null)

	const validateInput = useCallback((value) => {
		const normalizedValue = p2e(value)

		if (!normalizedValue || normalizedValue.length === 0) {
			setSignMethod(null)
			setValidationStatus(VALIDATION_STATUS.NORMAL)
			return false
		}

		// Check if it's a number (not email)
		if (!isNaN(normalizedValue)) {
			setValidationStatus(VALIDATION_STATUS.ERROR)
			return false
		}

		// Validate email format
		const isValidEmail = validEmailRegex.test(normalizedValue)
		setSignMethod('email')
		setValidationStatus(isValidEmail ? VALIDATION_STATUS.VALID : VALIDATION_STATUS.ERROR)
		return isValidEmail
	}, [])

	const resetValidation = useCallback(() => {
		setValidationStatus(VALIDATION_STATUS.NORMAL)
		setSignMethod(null)
	}, [])

	return {
		validationStatus,
		signMethod,
		validateInput,
		setValidationStatus,
		resetValidation,
	}
}

